/* Quote-first installation card (ducted). Supply Only | Supply + Installation, postcode check, quote button.
   No cart writes. A postcode result is indicative and never confirms a booking. */
(() => {
  if (customElements.get('awa-system-installation-card')) return;

  class AWASystemInstallationCard extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-awa-system-postcode-form]');
      this.input = this.querySelector('[data-awa-system-postcode]');
      this.result = this.querySelector('[data-awa-system-result]');
      this.quote = this.querySelector('[data-awa-product-quote-open]');
      this.options = this.querySelector('[data-awa-sys-options]');
      this.modes = [...this.querySelectorAll('[data-awa-sys-mode]')];
      try {
        this.rules = JSON.parse(this.querySelector('[data-awa-system-coverage-rules]')?.textContent || '""');
      } catch (_) {
        this.rules = '';
      }
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.modes.forEach((m) => m.addEventListener('change', () => this.setMode(m.value), { signal }));
      this.setMode(this.modes.find((m) => m.checked)?.value || 'supply');
      if (!this.form || !this.input || !this.result || !this.quote) return;
      this.input.addEventListener('input', () => {
        this.quote.dataset.installationPostcode = this.input.value.trim();
        this.show('', 'neutral');
      }, { signal });
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.check();
      }, { signal });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.initialized = false;
    }

    setMode(mode) {
      const install = mode === 'install';
      if (this.options) this.options.hidden = !install;
      this.modes.forEach((m) => { if (m.hasAttribute('aria-controls')) m.setAttribute('aria-expanded', String(install)); });
      if (this.quote) this.quote.dataset.quotePreselect = install ? 'Supply + Installation' : 'Supply Only';
    }

    show(message, state = 'neutral') {
      if (!this.result) return;
      this.result.dataset.state = state;
      this.result.textContent = message;
    }

    check() {
      const postcode = String(this.input?.value || '').trim();
      const engine = window.AWAInstallationCoverage;
      this.quote.dataset.installationPostcode = postcode;
      if (!/^[0-9]{4}$/.test(postcode) || (engine?.isAustralianPostcode && !engine.isAustralianPostcode(postcode))) {
        this.show('Enter a valid 4-digit Australian postcode.', 'invalid');
        return;
      }
      if (!this.rules) {
        this.show('Installation for ' + postcode + ' is confirmed with your quote. Request a quote below and our team will assess your property.', 'pending');
        return;
      }
      if (!engine?.parseRules || !engine?.evaluate) {
        this.show('Installation for ' + postcode + ' is confirmed with your quote.', 'pending');
        return;
      }
      const parsed = engine.parseRules(this.rules);
      if (!parsed.valid) {
        this.show('Installation for ' + postcode + ' is confirmed with your quote.', 'pending');
        return;
      }
      const decision = engine.evaluate({ enabled: true, rules: this.rules, parsed }, postcode);
      if (decision.available === true) {
        this.show('\u2713 We install in ' + postcode + '. Request a quote below for your property.', 'available');
      } else if (decision.available === false) {
        this.show(postcode + ' is outside our usual installation area. Request a quote and we\u2019ll check options for you.', 'unavailable');
      } else {
        this.show('Installation for ' + postcode + ' is confirmed with your quote.', 'pending');
      }
    }
  }

  customElements.define('awa-system-installation-card', AWASystemInstallationCard);
})();
